export const headerHeight = 50;
export const columnOptionsHeaderHeight = 50;
export const columnOptionsViewSelectContainer = 44;
export const columnOptionsDescriptionContainerHeight = 32;
export const columnOptionsFooterHeight = 52;
